import type {Field008Definitions, Fond} from 'typings/portaro.be.types';
import type {Component} from 'typings/portaro.fe.types';
import type {ModalWindowBindings, ModalWindowResolveValues} from 'src/modals/modals.types';
import KpField8EditorModal from './KpField8EditorModal.svelte';

export interface Field8EditorModalModel {
    value: string;
    fond: Fond;
    definitions: Field008Definitions;
}

export class Field8EditorModalComponent implements Component<ModalWindowBindings<Field8EditorModalModel>> {
    public static componentName = 'field8EditorModal';

    public bindings = {
        resolve: '<'
    } as const;
    public controller = Field8EditorModalComponentController;
    public templateUrl = require('./field8-editor-modal.component.tpl.ftl');
}

class Field8EditorModalComponentController implements ModalWindowBindings<Field8EditorModalModel> {
    public component = KpField8EditorModal;
    public resolve: ModalWindowResolveValues<Field8EditorModalModel>;
}